export default "__VITE_ASSET__B44TsRuL__"